"use strict";
function isString(value) {
    return typeof value === 'string';
}
exports.isString = isString;
function hasLength(value) {
    return value.toString().trim().length > 0;
}
exports.hasLength = hasLength;
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-brpipes/src/utils.js
// module id = ./node_modules/ng2-brpipes/src/utils.js
// module chunks = vendor